// Public types — kept in sync với worker/src/types.ts. SDK consumers import these.

export type ChatRole = "system" | "user" | "assistant" | "tool";

export interface ToolCall {
  id: string;
  type: "function";
  function: {
    name: string;
    arguments: string;
  };
}

export interface ChatMessage {
  role: ChatRole;
  content: string;
  tool_calls?: ToolCall[];
  tool_call_id?: string;
  name?: string;
}

export type ToolRisk = "low" | "medium" | "high";

/// Tool def cho frontend. `execute` chỉ tồn tại ở client-side; khi gửi lên gateway
/// chỉ gửi {name, description, parameters}.
///
/// `execute` dùng `any` để frontend tự narrow args trong impl. SDK không validate
/// runtime — model + JSON Schema là contract; impl tự cast nếu cần.
export interface Tool {
  name: string;
  description: string;
  parameters: Record<string, unknown>;     // JSON Schema
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  execute: (args: any) => Promise<unknown>;
  needsApproval?: boolean;
  risk?: ToolRisk;
}

export type FinishReason = "stop" | "tool_calls" | "length" | "error";

export interface InferConfig {
  model?: string;
  max_tokens?: number;
  temperature?: number;
  system?: string;
}

/// Events emit từ SSE stream của gateway.
export type StreamEvent =
  | { type: "delta"; content: string }
  | { type: "tool_calls"; tool_calls: ToolCall[] }
  | { type: "usage"; prompt_tokens: number; completion_tokens: number }
  | { type: "done"; finish_reason: FinishReason }
  | { type: "error"; code: string; message: string };

export class GatewayError extends Error {
  constructor(
    message: string,
    public status: number,
    public code: string,
  ) {
    super(message);
    this.name = "GatewayError";
  }
}
